import { PHONE, locationSchema } from "../structured-data-core";

export function getIndianapolisStructuredData() {
  const url = "https://restorehair.com/locations/indiana/indianapolis/";
  const description =
    "Find out about your hair transplant options in Indianapolis with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Indianapolis", "8888 Keystone Crossing, Suite 1300", "Indianapolis", "IN", PHONE, url, description),
  ];
}
